import React, { useContext } from "react";
import { Box } from "@chakra-ui/react";
import { Message } from "./components/Message";
import { useState, useEffect } from "react";
import FullPageLoader from "../../components/fullPageLoader";
import { getResponse } from "./services/getMessages";
import { useSelector } from "react-redux";
import { UserProfileContext } from "../../context/UserContext";

export const Messages = () => {
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);
  const [response, setResponse] = useState([]);
  const userId = useSelector((state) => state?.auth?.userId);
  const { activeAccount, userProfile } = useContext(UserProfileContext);
  const estateId =
    activeAccount?.estateId ||
    (userProfile?.estates?.length &&
      (userProfile.estates[0]?.estateId?._id ||
        userProfile.estates[0]?.estateId)) ||
    null;

  useEffect(() => {
    getResponse(setResponse, setLoading, estateId);
  }, [userId, refresh, estateId]);
  console.log("message", response, userId);

  return loading ? (
    <FullPageLoader />
  ) : (
    <Box mx="20px">
      {/* <Box
        color="#264653"
        fontSize={"27px"}
        fontWeight="bold"
        py={"20px"}
        pl={["5px", "5px", "0"]}
      >
        Support
      </Box> */}
      <Message
        setRefresh={setRefresh}
        response={response}
        estateId={estateId}
      />
    </Box>
  );
};
